var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18px",
  height: "16px",
  viewBox: "0 0 18 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Path") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Open-Shifts",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "2.2-Open-Shifts--Specific-shift--",
  transform: "translate(-296.000000, -572.000000)",
  fill: "#6467EF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M313.777778,579.994864 C313.777778,579.705481 313.600198,579.525531 313.350716,579.393975 C313.335704,579.384494 296.471704,572.028444 296.471704,572.028444 C296.428444,572.008889 296.382815,572 296.336593,572 C296.272,572 296.208198,572.01758 296.152296,572.053728 C296.057086,572.114963 296,572.221037 296,572.333037 L296,579.004247 C296,579.184 296.14242,579.33037 296.322963,579.337284 L313.012741,580 L296.322963,580.661531 C296.14242,580.669037 296,580.815407 296,580.995358 L296,587.666568 C296,587.778173 296.057086,587.884247 296.152296,587.946074 C296.208,587.981432 296.272,588 296.336593,588 C296.382222,588 296.428049,587.990716 296.471704,587.97116 L313.166815,580.69116 C313.490765,580.568296 313.777778,580.345481 313.777778,579.994864 Z",
  id: "Path"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export default ForwardRef;